import type { SVGProps } from 'react';

export function LocationIcon({ className, ...props }: SVGProps<SVGSVGElement>) {
  return (
    <svg
      className={className}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      {...props}
    >
      <path
        d="M16.6668 8.33073C16.6668 12.4916 12.051 16.8249 10.501 18.1632C10.3566 18.2718 10.1808 18.3305 10.0002 18.3305C9.8195 18.3305 9.64373 18.2718 9.49933 18.1632C7.94933 16.8249 3.3335 12.4916 3.3335 8.33073C3.3335 6.56262 4.03588 4.86693 5.28612 3.61668C6.53636 2.36644 8.23205 1.66406 10.0002 1.66406C11.7683 1.66406 13.464 2.36644 14.7142 3.61668C15.9645 4.86693 16.6668 6.56262 16.6668 8.33073Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.5 9.44792L9.16667 11.1146L12.5 7.78125"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

